module.exports = __webpack_public_path__ + "img/CB0030_hamster_stroke.57bed39c.png";